import makeStyles from "@mui/styles/makeStyles";
import { getBrandCustom } from "Util/getCustomColor";
import { Theme, styled } from "@mui/material/styles";

const styles = makeStyles<Theme>((theme) => ({
  mainGrid: {
    [theme.breakpoints.down("sm")]: {
      marginBottom: "15px",
    },
  },
  title: {
    fontSize: "18px",
    color: "#465869",
    fontWeight: 700,
    lineHeight: "36px",
    marginBottom: "10px",
  },
  button: {
    marginRight: "5px",
  },
  iconButton: {
    marginRight: "5px",
  },
  iconSearchButton: {
    padding: "5px",
  },
  rowGridType: {
    width: "100%",
    justifyContent: "space-between",
    alignItems: "flex-end",
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
      alignItems: "flex-start",
      gap: 12,
    },
  },
  rowGridButtons: {
    width: "70%",
    justifyContent: "flex-end",
    display: "flex",
    flexDirection: "row",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      justifyContent: "flex-start",
      gap: 12,
      "& > div": {
        width: "calc(100% - 335px)",
      },
    },
  },
  containerInfoNavigation: {
    width: "100%",
    flexDirection: "row",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    margin: "15px 0",
    [theme.breakpoints.down("sm")]: {
      margin: "5px 0",
    },
  },
  gridFolders: {
    paddingTop: "15px",
  },
  inputFile: {
    display: "none",
  },
  validFormatLabel: {
    font: "700 14px/21px Manrope",
    display: "flex",
    gap: "8px",
    color: getBrandCustom("primaryColor", "#308cdb"),
    "& > span": {
      fontWeight: 500,
      color: "#667085",
      textTransform: "uppercase",
    },
  },
  validFormatLabelDescription: {
    fontWeight: 500,
    color: "#667085",
    textTransform: "uppercase",
  },
  w100: {
    width: "100%",
  },
}));

export const Container = styled("div")({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
});

export const LeftContent = styled("div")({
  display: "flex",
  flexDirection: "column",
});

export default styles;
